import { OfferRecord, SiteLocale } from 'apps/website/types/dato';
import { OfferProps } from '../../types';
import { linkResolver } from 'apps/website/src/utils/linkResolver';
import { mapperPricingRanges } from './mapperPricingRanges';
import { mapperFirstPayrollOffer } from './mapperFirstPayrollOffer';

export const mapperOffer = (
  offer: OfferRecord,
  locale: SiteLocale,
): OfferProps => {
  let link = offer.link?.externalLink as string | undefined;
  if (offer.link?.internalLink) {
    link = linkResolver(offer.link.internalLink, locale, offer.link.urlParams);
  }
  let linkOnDemand = offer.linkOnDemand?.externalLink as string | undefined;
  if (offer.linkOnDemand?.internalLink) {
    linkOnDemand = linkResolver(
      offer.linkOnDemand.internalLink,
      locale,
      offer.linkOnDemand.urlParams,
    );
  }
  return {
    ...offer,
    __typename: 'DatoCmsOffer',
    title: offer.title || undefined,
    link: link,
    isFirstPayroll: false,
    linkOnDemand: linkOnDemand,
    icon: 'plan',
    highlightedLabel: offer.highlightedLabel,
    tag: offer.tag || undefined,
    pricingRange: mapperPricingRanges(offer.pricingRange),
    firstPayrollOffer: offer.associatedFirstPayrollOffer
      ? mapperFirstPayrollOffer({ offer, locale })
      : undefined,
  };
};
